export default __webpack_public_path__ + "311d5ad003a76a352cebfd893588b62b.png";